<template>
  <div class="">
    <img class="admineArriveLogo" :src="this.logo" alt="Logo" :style="getStyle()" />
    <div class="adminArriveText">
      {{ name }} {{ text }}
    </div>
  </div>
</template>

<script>
import specs from "@/specs";
const store = require("@/store").default;
import utils from '../utils'

export default {
  name: "AgentAssign",
  props: {
    name: String
  },
  data: () => {
    return {
      admin_avatar: specs._ADMIN_IMG_AVATAR,
      logo: specs._IMG_AVATAR,
      text: (store.state.user.lang === "en") ? "has joined the conversation" : "a rejoint la conversation",
    };
  },
   mounted() {
    setTimeout(() => {
        utils.scrollDown()
      }, 250);
  },

  methods: {
    getStyle() {
      if (store.state.config.storeId == 49)
        return "filter: invert(1) !important; width: 20%; margin-bottom: 10px";
      else if (store.state.config.storeId == 46)
        return "margin-top: 20px; margin-bottom: 20px;";
      else
        return "";
    }
  }
};
</script>
